<template>
  <div>
    <div v-if="loading">
      <div class="animated loader"></div>
    </div>
    <div class="container pt-2">
      <div class="row">
        <div class="col-12">
          <p class="logo text-center">
            <svg width="56" height="66" viewBox="0 0 56 66" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0627 7.05834C33.0627 17.0093 27.3645 22.5161 17.755 22.5161C16.0433 22.5161 14.4558 22.3414 13.0024 21.998C15.4055 27.8663 21.172 32 27.9036 32C36.7934 32 44 24.791 44 15.8982C44 8.81039 39.422 2.79222 33.0627 0.641137V7.05834ZM12 13.399C13.293 15.0897 15.2718 15.8499 17.8033 15.8499C22.5839 15.8499 25.3364 13.1931 25.3364 6.7685V0C18.4799 1.09935 13.0699 6.53048 12 13.399Z" fill="#0300e2"/>
              <path d="M8.54966 46.316V51.104C8.54966 52.886 7.61366 53.714 6.31766 53.714C5.07566 53.714 4.35566 52.994 4.35566 51.374V46.316H1.54766V51.788C1.54766 54.776 3.25766 56.144 5.68766 56.144C6.87566 56.144 7.95566 55.694 8.69366 54.848V56H11.3577V46.316H8.54966ZM19.6111 43.4H14.1571V56H17.0731V52.526H19.6111C22.9771 52.526 25.0831 50.78 25.0831 47.972C25.0831 45.146 22.9771 43.4 19.6111 43.4ZM19.4491 50.15H17.0731V45.776H19.4491C21.2311 45.776 22.1311 46.586 22.1311 47.972C22.1311 49.34 21.2311 50.15 19.4491 50.15ZM29.6489 47.594V46.316H26.9669V56H29.7749V51.428C29.7749 49.574 30.8009 48.728 32.3489 48.728C32.5649 48.728 32.7449 48.746 32.9789 48.764V46.172C31.4849 46.172 30.3329 46.658 29.6489 47.594ZM39.1686 56.144C42.2466 56.144 44.4786 54.074 44.4786 51.158C44.4786 48.242 42.2466 46.172 39.1686 46.172C36.0906 46.172 33.8406 48.242 33.8406 51.158C33.8406 54.074 36.0906 56.144 39.1686 56.144ZM39.1686 53.84C37.7646 53.84 36.6846 52.832 36.6846 51.158C36.6846 49.484 37.7646 48.476 39.1686 48.476C40.5726 48.476 41.6346 49.484 41.6346 51.158C41.6346 52.832 40.5726 53.84 39.1686 53.84ZM51.0356 56.144C53.0696 56.144 54.6716 55.244 55.3736 53.696L53.1956 52.508C52.6736 53.444 51.8996 53.84 51.0176 53.84C49.5956 53.84 48.4796 52.85 48.4796 51.158C48.4796 49.466 49.5956 48.476 51.0176 48.476C51.8996 48.476 52.6736 48.89 53.1956 49.808L55.3736 48.638C54.6716 47.054 53.0696 46.172 51.0356 46.172C47.8856 46.172 45.6356 48.242 45.6356 51.158C45.6356 54.074 47.8856 56.144 51.0356 56.144Z" fill="#0300e2"/>
            </svg>
          </p>
          <div v-if="!signedup">
            <h3 class="welcome text-center">{{$t('signup')}}</h3>
            <p class="commit">{{$t('signup-subtitle')}}</p>
          </div>
          <div v-if="signedup">
            <h3 class="welcome text-center">{{$t('signup-thankyou')}}</h3>
          </div>
          <div class="row">
            <div class="col-12 d-flex flex-row justify-content-center">
              <div class="content-box content-box-signup" v-if="!signedup">
                <form v-if="step == 1" @submit.prevent="submit">
                  <div class="formatting">
                    <label class="has-float-label">
                      <input type="text" name="email" :placeholder="$t('email-placeholder')" v-on:click="$event.target.select()" autocomplete="off" @focus="flag_email = true" @blur="flag_email = false" v-model="$v.email.$model" :class="[isEmailValid()]" :disabled="loading">
                      <span>{{$t('email')}}</span>
                      <div v-if="flag_email" class="icon-inside icon-with">
                        <font-awesome-icon icon="envelope" />
                      </div>
                      <div v-else class="icon-inside icon-without">
                        <font-awesome-icon icon="envelope" />
                      </div>
                      <div class="error" v-if="!$v.email.required">{{$t('field-required')}}</div>
                      <div class="error" v-if="!$v.email.email">{{$t('field-email')}}</div>
                    </label>
                  </div>
                  <div class="formatting final-pass">
                    <label class="has-float-label">
                      <input type="password" name="pass" :placeholder="$t('password-placeholder')" autocomplete="off" v-on:change="checkPassword()" @focus="flag_pass = true" @blur="flag_pass = false" v-model="$v.password.$model" :disabled="loading">
                      <password :toggle="true" v-model="password" :strength-meter-only="true"/>
                      <span>{{$t('password')}}</span>
                      <div v-if="flag_pass" class="icon-inside icon-with">
                        <font-awesome-icon icon="key" />
                      </div>
                      <div v-else class="icon-inside icon-without">
                        <font-awesome-icon icon="key" />
                      </div>
                      <div class="error" v-if="!$v.password.required">{{$t('field-required')}}</div>

                    </label>
                  </div>

                  <div class="formatting final-pass">
                    <label class="has-float-label">
                    <span>{{$t('feedback-reason')}}</span>
                      <select name="reason" class="form-control" id="reason" v-model="$v.reason.$model" @focus="flag_reason = true" @blur="flag_reason = false" v-on:change="checkReason()" :disabled="loading">
                        <option value="" selected>{{$t('feedback-choose')}}</option>
                        <option v-for="reason in reasons" :value="reason.key" v-bind:key="reason.key">{{reason.text}}</option>
                      </select>
                      <div class="error" v-if="!$v.reason.required">{{$t('field-required')}}</div>
                      <div v-if="flag_reason" class="icon-inside icon-with">
                        <font-awesome-icon icon="bullseye" />
                      </div>
                      <div v-else class="icon-inside icon-without">
                        <font-awesome-icon icon="bullseye" />
                      </div>
                    </label>
                  </div>

                  <div class="formatting final-pass">
                    <label class="has-float-label">
                      <span>{{$t('feedback-details')}}</span>
                      <textarea name="details" class="form-control" autocomplete="off" id="details" v-on:click="$event.target.select()" v-model="$v.details.$model" @focus="flag_details = true" @blur="flag_details = false"  :disabled="loading" :placeholder="$t('feedback-details-placeholder')"/>
                      <div v-if="flag_details" class="icon-inside icon-with">
                        <font-awesome-icon icon="info" />
                      </div>
                      <div v-else class="icon-inside icon-without">
                        <font-awesome-icon icon="info" />
                      </div>
                    </label>
                  </div>

                  <!--div class="formatting final-pass">
                    <label class="has-float-label">
                      <span>{{$t('feedback-phone')}}</span>
                      <input type="text" name="phone" :placeholder="$t('feedback-phone-placeholder')" v-on:click="$event.target.select()" autocomplete="off" @focus="flag_phone = true" @blur="flag_phone = false" v-on:click="$event.target.select()" v-model="$v.phone.$model" :class="[isEmailValid()]" :disabled="loading">
                      <div v-if="flag_phone" class="icon-inside icon-with">
                        <font-awesome-icon icon="phone" />
                      </div>
                      <div v-else class="icon-inside icon-without">
                        <font-awesome-icon icon="phone" />
                      </div>
                    </label>
                  </div-->

                  <div class="formatting final-pass">
                    <label class="has-float-label">
                      <span>{{$t('feedback-source')}}</span>
                      <select name="source" class="form-control" id="source" v-model="source" @focus="flag_source = true" @blur="flag_source = false" :disabled="loading">
                        <option value="" selected>{{$t('feedback-choose')}}</option>
                        <option v-for="source in sources" :value="source" v-bind:key="source">{{$t('feedback-source-' + source)}}</option>
                      </select>
                      <div v-if="flag_source" class="icon-inside icon-with">
                        <font-awesome-icon icon="info-circle" />
                      </div>
                      <div v-else class="icon-inside icon-without">
                        <font-awesome-icon icon="info-circle" />
                      </div>
                    </label>
                  </div>

                  <div class="formatting final-pass">
                    <label class="has-float-label">
                      <input type="text" name="promo_code" :placeholder="$t('promo_code-placeholder')" v-on:click="$event.target.select()" @focus="flag_promo = true" @blur="flag_promo = false" autocomplete="off" v-model="promo_code" :disabled="loading">
                      <span>{{$t('promo_code')}}</span>
                      <div v-if="flag_promo" class="icon-inside icon-with">
                        <font-awesome-icon icon="gift" />
                      </div>
                      <div v-else class="icon-inside icon-without">
                        <font-awesome-icon icon="gift" />
                      </div>
                    </label>
                  </div>


                  <div class="check">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="customControlAccept" v-on:click="checkCheckbox(1, $event)" :disabled="loading">
                      <label class="custom-control-label" for="customControlAccept" v-html="$t('accept-terms')"></label>
                    </div>
                    <!--vue-recaptcha ref="recaptcha" :sitekey="recaptcha_key" :loadRecaptchaScript="true" @verify="onVerify" @expired="onExpired"></vue-recaptcha-->

                  </div>

                  <!--p>
                    <button type="button" v-on:click="changeStep()" v-bind:class="(loading || email_error || flag_check || password_error) ? 'btn-disable' : ''" :disabled="loading || email_error || flag_check || password_error || recaptcha_error">
                      <span v-if="loading">{{$t('sending')}}</span>
                      <span v-if="!loading">{{$t('next')}}</span>
                    </button>
                  </p-->
                  <p>
                    <button type="submit" v-bind:class="(loading || email_error || flag_check || password_error || reason_error) ? 'btn-disable' : ''" :disabled="loading || email_error || flag_check || password_error || recaptcha_error || reason_error">
                      <span v-if="loading">{{$t('sending')}}</span>
                      <span v-if="!loading">{{$t('signup-button')}}</span>
                    </button>
                  </p>
                  <div v-if="response_message != ''">
                    <p v-bind:class="response_result ? 'alert alert-info text-center text-info mt-4' : 'alert alert-danger text-center text-danger mt-4'">
                      <span v-if="!response_result">{{$t('signup-ko')}} {{response_message}}</span>
                      <span v-else>{{$t('signup-ok')}}</span>
                    </p>
                  </div>
                  <p class="forgot text-center">
                    <router-link :to="'forgot'">{{$t('remember-password')}}</router-link>
                  </p>
                </form>
                <!--form @submit.prevent="submit" v-if="step != 1">

                  <p>{{$t('feedback-title')}}</p>
                  <br>
                  <br>

                  <div class="formatting">
                    <label class="has-float-label">
                    <span>{{$t('feedback-size')}}</span>
                      <select v-model="size" class="form-control" id="size" required>
                        <option value="" selected>{{$t('feedback-choose')}}</option>
                        <option v-for="size in sizes" :value="size" v-bind:key="size">{{size}}</option>
                      </select>
                    </label>
                  </div>

                  <div class="formatting final-pass">
                    <label class="has-float-label">
                    <span>{{$t('feedback-industry')}}</span>
                      <select v-model="industry" class="form-control" id="industry">
                        <option value="" selected>{{$t('feedback-choose')}}</option>
                        <option v-for="industry in industries" value="industry" v-bind:key="industry">{{industry}}</option>
                      </select>
                    </label>
                  </div>

                  <div class="formatting final-pass">
                    <label class="has-float-label">
                    <span>{{$t('feedback-role')}}</span>
                      <select v-model="role" class="form-control" id="role">
                        <option value="" selected>{{$t('feedback-choose')}}</option>
                        <option v-for="role in roles" value="role" v-bind:key="role">{{role}}</option>
                      </select>
                    </label>
                  </div>

                  <div class="formatting final-pass">
                    <label class="has-float-label">
                    <span>{{$t('feedback-reason')}}</span>
                      <select v-model="reason" class="form-control" id="reason">
                        <option value="" selected>{{$t('feedback-choose')}}</option>
                        <option v-for="reason in reasons" :value="reason.key" v-bind:key="reason.key">{{reason.text}}</option>
                      </select>
                    </label>
                  </div>

                  <div class="formatting final-pass">
                    <label class="has-float-label">
                    <span>{{$t('feedback-source')}}</span>
                      <select v-model="source" class="form-control" id="source">
                        <option value="" selected>{{$t('feedback-choose')}}</option>
                        <option v-for="source in sources" :value="source" v-bind:key="source">{{source}}</option>
                      </select>
                    </label>
                  </div>

                  <br>

                  <p>
                    <button type="submit" v-bind:class="(loading || email_error || flag_check || password_error) ? 'btn-disable' : ''" :disabled="loading || email_error || flag_check || password_error || recaptcha_error">
                      <span v-if="loading">{{$t('sending')}}</span>
                      <span v-if="!loading">{{$t('signup-button')}}</span>
                    </button>
                  </p>

                  <p class="forgot text-center">
                    <router-link :to="'forgot'">{{$t('remember-password')}}</router-link>
                  </p>

                  <div v-if="response_message != ''">
                    <p v-bind:class="response_result ? 'alert alert-info text-center text-info mt-4' : 'alert alert-danger text-center text-danger mt-4'">
                      <span v-if="!response_result">{{$t('signup-ko')}} {{response_message}}</span>
                      <span v-else>{{$t('signup-ok')}}</span>
                    </p>
                  </div>
                </form-->
              </div>
              <div class="alert alert-info text-center text-info mt-4" v-if="signedup">
                <p><span>{{$t('signin-ok')}}</span></p>
              </div>
            </div>
          </div>
          <h3 class="no-account">{{$t('signin-user')}}</h3>
          <h5 class="signed" v-html="$t('signin-user-description')"></h5>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
//import VueRecaptcha from 'vue-recaptcha';
import Footer from '@/components/Footer.vue'
import Password from 'vue-password-strength-meter'
import { required, email } from 'vuelidate/lib/validators'
import i18n from '@/plugins/i18n';

export default {
  name: 'SignUp',
  data () {
    return {
      loading: false,
      flag_email: false,
      flag_check: true,
      flag_check_subscription: false,
      email_error: true,
      is_checking: false,
      flag_pass: false,
      flag_details: false,
      flag_reason: false,
      flag_phone: false,
      flag_promo: false,
      password_error: true,
      reason_error: true,
      promo_code: "",
      email: '',
      password: '',
      newsletter: true,
      signedup: false,
      // reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      //reg: /^(([^<>()[]\\.,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      reg: /^(([^<>().,;:\s@"]+(\.[^<>().,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      response_result: true,
      response_message: '',
      //recaptcha_key: '6Ldc6-IUAAAAAB3XjLtadKHOnFaxuy4jEI20CsNv',//invisible captcha
      recaptcha_key: '6LfM6uIUAAAAAI3xuETA43P-qiyJL8JhMZWyFs8z',//checkbox
      recaptcha_error: false,

      //Variable form feedback
      step: 1,
      sizes: ["Self-employed", "1-10", "11-50","51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"],
      size: "",
      industries: ["Information Technology & Services", "Hospital & Health Care", "Construction", "Retail",
      "Education Management", "Financial Services", "Accounting", "Computer Software", "Higher Education", "Automotive"].sort().concat(["Other"]),
      industry: "",
      roles: ["Executive Management", "Finance Operations", "Business Operations", "Marketing", "Customer Success", "Sales", "Data and Analytics", "Engineering", "Human Resources"].sort(),
      role: "",
      sources: ["email", "event", "friend", "other", "referral", "search_engine", "social_media"],
      source: "",
      reasons: ["My sales funnel", "My recruitment process", "My email marketing campaigns", "My sms marketing campaigns", "My existing data", "My e-shop catalog"].map(function(reason) {
//        reasons: ["My sales funnel", "My recruitment process", "My email marketing campaigns", "My sms marketing campaigns", "My forms", "My existing data", "My e-shop catalog"].map(function(reason) {
      //reasons: ["My email marketing campaigns", "My sms marketing campaigns", "My existing data"].map(function(reason) {
        return {
          key: reason,
          text: i18n.t('feedback-reason-' + reason)
        }
      }).sort((a, b) => (a.text > b.text) ? 1 : -1),
      reason: "",
      details: "",
      phone: ""
    }
  },
  mounted() {
    //var email = localStorage && localStorage.configEmail && localStorage.configEmail !== 'undefined' ? localStorage.configEmail : "";
    this.email = localStorage && localStorage.configEmail && localStorage.configEmail !== 'undefined' ? localStorage.configEmail : "";
    this.promo_code = this.$route.params.referral || "";
//    if (!email.length) {
//    } else {
      //this.$router.push('/login/')
//    }
  },
  components: {
    Footer,
    Password,
    //VueRecaptcha
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    },
    reason: {
      required
    },
    details: {
    },
    phone: {
     numeric: true
    }/*
    size: {
      required
    },
    industry: {
      required
    },
    role: {
      required
    },
    reason: {
      required
    },
    source: {
      required
    }*/
  },
  methods: {
    onVerify: function (response) {
      if (response && response.length) {
        //console.log('Verify: ' + response)
        this.recaptcha_error = false;
      }
    },

    onExpired: function () {
      console.log('Expired')
    },

    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    },

    resetErrors: function() {
      this.email_error = false
      this.password_error = false
      this.reason_error = false
      this.loading = false
      this.response_result = false
      this.response_message = ""
    },
    isEmailValid: function() {
      return (this.email == "")? "" : (this.reg.test(this.email)) ? this.email_error = false : this.email_error = true;
    },
    checkPassword: function() {
      this.password_error = !this.password.length
    },
    checkReason: function() {
      this.reason_error = !this.reason.length
      console.log(this.reason_error);
    },
    checkCheckbox: function(value, event) {
      if (event.target.checked)
        this.flag_check = false
      else
        this.flag_check = true
      console.log(this.reason_error);
    },
    checkCheckboxSubscription: function(value, event) {
      this.newsletter = event.target.checked;
      if (event.target.checked) {
        this.flag_check_subscription = false
      } else {
        this.flag_check_subscription = true
      }
    },

    hasCompletedFiscalDataCheck: function() {
      return this.user && this.user.company &&
        this.user.company.address && this.user.company.address.length > 0 &&
        this.user.company.cif && this.user.company.cif.length > 0 &&
        this.user.company.zipcode && this.user.company.zipcode.length > 0 &&
        this.user.company.city && this.user.company.city.length > 0 &&
        this.user.country_code.length > 0 &&
        this.user.company.name && this.user.company.name.length > 0 &&
        this.user.company.phone && this.user.company.phone.length > 0 &&
        this.user.company.province && this.user.company.province.length > 0;
    },

    initDrift: function() {
      if (process.env.NODE_ENV === 'production') {
        this.$drift.config({
          locale: 'en',//this.$i18n.locale.toLowerCase().indexOf("es") !== -1 ? "es" : "en",
          messages: {
            welcomeMessage: this.$t('drift-welcome'),
            awayMessage: this.$t('drift-away'),
            emailCaptureMessage: this.$t('drift-email'),
            thankYouMessage: this.$t('drift-thankyou')
          }
        });
        //console.log("aaaa");
        if (this.user) {
          var data = {
            name: this.user.name,
            email: this.user.email
          }
          if (this.user.company && this.user.company.phone.length) {
            data.phone = this.user.company.phone;
          }
          this.$drift.identify(this.user.email, data);
        }
      }
    },

    getUser: function() {
      var config = {
        headers: {
          "Authorization": "Basic " + btoa(localStorage.configEmail + ":" + localStorage.token),
          "Content-Type": "application/json"
        }
      };
      var url = '/api/v2/profile';
      this.$http.get(url, config).then((results) => {
        this.user = results.data;
        this.initDrift();

        var profileNeedsComplete = !this.hasCompletedFiscalDataCheck();
        this.$store.commit('setNeedsComplete', profileNeedsComplete)

        setTimeout(()=>{
          var signup_reason = this.user.signup_reason.replace(/ /g, "-").toLowerCase();
          localStorage.setItem('signupReason', signup_reason);
          //console.log(signup_reason);
          if (this.$route.query && this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          //} else if (profileNeedsComplete) {
          //  this.$router.push("settings/profile");
          } else if (signup_reason.length) {
            this.$router.push('/welcome/' + signup_reason);
          } else {
            this.$router.push('/tools');
          }
        }, 2000);
      });
    },

    submitLogin: function() {
      var data = {
        email: this.email,
        password: this.password
      }
      this.loading = true
      this.logged = false;
      this.$http.post('/api/v2/signin', data).then((results) => {
        this.signedup = true
        this.loading = false
        this.response_result = results.data.result,
        this.response_message = results.data.message,
        localStorage.token = results.data.apiKey;

        if (results.data.apiKey) {
          this.logged = true;
          localStorage.configEmail = this.email;
          this.$i18n.locale = navigator.language.toLowerCase().indexOf("es") !== -1 ? "es" : "en"
          this.getUser()
        }
      });
    },

    showLoginErrors: function(results) {
      this.response_result = results.data.result
      this.response_message = results.data.message
    },

    submit: function() {
      //this.resetRecaptcha();
      this.loading = true
      this.response_result = false
      this.response_message = ""

      var data = {
        email: this.email,
        promo_code: this.promo_code || "",
        password: this.password,
        newsletter: this.newsletter,
        plan: 'basic',
        size: this.size,
        industry: this.industry,
        role: this.role,
        source: this.source,
        reason: this.reason,
        details: this.details,
        phone: this.phone
      }
      this.$http.post('/api/v2/signup', data).then((results) => {
        this.loading = false
        localStorage.configEmail = this.email
        this.showLoginErrors(results);
        if (this.response_result) {
          //this.email = ''
          //this.password = ''
          //this.promo_code = ''
          this.flag_check = false
          this.flag_check_subscription = false
          this.submitLogin();
        }
      })
    },

    changeStep: function () {
      this.loading = true;
      //this.$http.get('/api/v2/signup/' + this.email).then((results) => {
        this.loading = false;
        //this.showLoginErrors(results);
        //if (this.response_result) {
          //this.response_result = true;
          //this.response_message = "";
          this.step = 2;
        //}
      //});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../assets/css/login_signup.css';
</style>
